var exports = {
  "_F": "stackContainer__WJ-0nq",
  "h_": "description__p561Cc",
  "Yz": "stackNavList__CJSxcu",
  "Uz": "footerLayout__SlPygD",
  "zt": "footerActions__z4HSjQ",
  "AC": "branchItem__PXxrzE",
  "ZJ": "branchItemContent__w_Bphx",
  "BM": "groupDivider__7tlIZi",
  "DF": "groupDividerLabel__ZuWX5Q",
};

module.exports = exports;
